import React from 'react';
import PropTypes from 'prop-types';

import LocalAssignmentsStudentView from '../dashboard/LocalAssignmentsStudentView';

const propTypes = {};
const defaultProps = {};

function StudentAssignmentsDashboard(props) {
    return (
        <div>
            <LocalAssignmentsStudentView {...props} />
        </div>
    );
}

StudentAssignmentsDashboard.propTypes = propTypes;
StudentAssignmentsDashboard.defaultProps = defaultProps;

export default StudentAssignmentsDashboard;
